define("shared/utils/array-filters/remove-undefined-values", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.removeUndefinedValues = _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f
  /**
   * Removes the undefined values in an array
   *
   * @param arr Array of objects
   *
   * @returns Filtered array, excluding undefined values
   */
  const removeUndefinedValues = arr => {
    if (!arr || (0, _utils.isEmpty)(arr)) {
      return arr;
    }
    return arr.filter(_utils.isPresent);
  };
  _exports.removeUndefinedValues = removeUndefinedValues;
  var _default = _exports.default = removeUndefinedValues;
});